import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Content from "../../../Components/Dashboard/Content/Content";
import {
  UPDATE_PNL_POSITION,
  UPDATE_SELL_TIME,
  GET_SELL_TIME,
} from "../../../ReduxStore/Slice/Admin/AdminHelpSlice";
import { GET_COMPANY_INFOS } from "../../../ReduxStore/Slice/Admin/AdminSlice";
import toast from "react-hot-toast";

const SettingsPage = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const [pnl_position, setPnl_position] = useState("0");
  const [sell_time, setSellTime] = useState("never");

  useEffect(() => {
    loadSettings();
  }, []);

  const formatSellTime = (value) => {
    if (!value) return "00:00";

    if (!isNaN(Number(value))) return String(value).padStart(2, "0") + ":00";

    if (value.includes(":")) return value;

    return value;
  };

  const loadSettings = async () => {
    try {

      const companyResponse = await dispatch(GET_COMPANY_INFOS()).unwrap();
      if (companyResponse.status) {
        setPnl_position(companyResponse.data[0].pnl_position);
      }

      // Get sell time separately
      const sellTimeResponse = await dispatch(GET_SELL_TIME(token)).unwrap();
      if (sellTimeResponse.status && sellTimeResponse.data.length > 0) {
        setSellTime(formatSellTime(sellTimeResponse.data[0].sell_time));
      }
    } catch (error) {
      console.error("Error loading settings:", error);
      toast.error("Failed to load settings");
    }
  };


  const updatePnlPositionHandler = async (value) => {
    try {
      const res = await dispatch(
        UPDATE_PNL_POSITION({
          pnlposition: value,
          sell_time: sell_time,
          token,
        })
      ).unwrap();

      if (res.status) {
        setPnl_position(value);
        toast.success("PNL Position Updated");
      }
    } catch {
      toast.error("Failed to update");
    }
  };

  const updateSellTimeHandler = async (value) => {
  try {
    let hourOnly = value;

    // If dropdown gives "09:00", convert to "09"
    if (value.includes(":")) {
      hourOnly = value.split(":")[0];
    }

    const res = await dispatch(
      UPDATE_SELL_TIME({
        sell_time: hourOnly,  // 👈 only hour sending
        token,
      })
    ).unwrap();

    if (res.status) {
      setSellTime(value); // UI me 09:00 hi dikhana hai
      toast.success("Sell Time Updated");
    }
  } catch {
    toast.error("Failed to Update Sell Time");
  }
};


  return (
    <Content Page_title={"Settings"} button_status={false}>
      <div style={{ padding: "16px" }}>
        <h3 style={{ marginBottom: "24px" }}>P&L Position</h3>

        {/* ------- PNL POSITION ------- */}
        <div className="setting-card">
          <h5>Trade History Profit/Loss Position</h5>

          <div className="d-flex mt-2">
            <div className="form-check me-3">
              <input
                type="radio"
                className="form-check-input"
                name="pnlPosition"
                value="0"
                checked={pnl_position === "0"}
                onChange={(e) => updatePnlPositionHandler(e.target.value)}
              />
              <label className="form-check-label">Top</label>
            </div>

            <div className="form-check">
              <input
                type="radio"
                className="form-check-input"
                name="pnlPosition"
                value="1"
                checked={pnl_position === "1"}
                onChange={(e) => updatePnlPositionHandler(e.target.value)}
              />
              <label className="form-check-label">Bottom</label>
            </div>
          </div>
        </div>

        {/* ------- SELL TIME ------- */}
        <div className="setting-card mt-4">
          <h5>Auto Sell Trade</h5>

          <select
            className="form-select mt-3"
            value={sell_time}
            onChange={(e) => updateSellTimeHandler(e.target.value)}
          >
            <option value="never">Never SELL</option>

            {Array.from({ length: 25 }, (_, i) => {
              const hour = String(i).padStart(2, "0") + ":00";
              return (
                <option key={i} value={hour}>
                  {hour}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </Content>
  );
};

export default SettingsPage;
